import { CircleCheck, Info, OctagonAlert, TriangleAlert } from 'lucide-react';
import { cn } from '@/shell/lib/cn';

export type StatusTone = 'good' | 'notice' | 'serious' | 'critical';

const TONES = {
  good: { Icon: CircleCheck, text: 'text-good' },
  notice: { Icon: Info, text: 'text-ink' },
  serious: { Icon: TriangleAlert, text: 'text-warn' },
  critical: { Icon: OctagonAlert, text: 'text-critical' },
} as const;

/**
 * Zustand als Symbol + Wort + Farbe, nie Farbe allein (Kriterium D-8). Das Wort ist Pflicht.
 */
export function StatusBadge({
  tone,
  label,
  className,
}: {
  tone: StatusTone;
  label: string;
  className?: string;
}) {
  const { Icon, text } = TONES[tone];
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-control border border-line bg-surface-sunken px-2 py-0.5 text-fine font-semibold',
        text,
        className,
      )}
    >
      <Icon aria-hidden="true" className="size-4 shrink-0" />
      <span>{label}</span>
    </span>
  );
}
